import React, { useState } from 'react';
import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';
import './Contact.css';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    nume: '',
    prenume: '',
    telefon: '',
    angajat: '',
    datorii: '',
    alteRate: '',
    venitLunar: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Verificare dacă toate câmpurile sunt completate
    if (!formData.nume || !formData.prenume || !formData.telefon || !formData.angajat || !formData.datorii || !formData.alteRate || !formData.venitLunar) {
      alert('Vă rugăm să completați toate câmpurile!');
      return;
    }

    // Creează mesajul pentru WhatsApp
    const message = `
*Formular Nou de Contact*

*Nume:* ${formData.nume}
*Prenume:* ${formData.prenume}
*Număr de telefon:* ${formData.telefon}

*Sunteți angajat / pensionar de minim 3 luni?*
${formData.angajat}

*Aveți datorii neachitate / restanțe la alte bănci?*
${formData.datorii}

*Daca mai aveți alte rate, care este suma lunara pe care o platiți?*
${formData.alteRate} lei

*Care este venitul dumneavoastra net (in mana) lunar?*
${formData.venitLunar} lei
    `.trim();

    // Encodează mesajul pentru URL
    const encodedMessage = encodeURIComponent(message);
    
    // Creează link-ul WhatsApp
    const whatsappURL = `https://wa.me/40770905087?text=${encodedMessage}`;
    
    // Deschide WhatsApp
    window.open(whatsappURL, '_blank');
    
    // Reset formular
    setFormData({
      nume: '',
      prenume: '',
      telefon: '',
      angajat: '',
      datorii: '',
      alteRate: '',
      venitLunar: ''
    });
  };

  return (
    <div>
      <main className="contactpage">
        <div className="contact-container">
          <div className="contact-header">
            <h1>Solicită un Credit</h1>
            <p>Completează formularul și te vom contacta în cel mai scurt timp</p>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="nume">Nume *</label>
                <input
                  type="text"
                  id="nume"
                  name="nume"
                  value={formData.nume}
                  onChange={handleChange}
                  placeholder="Introduceți numele"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="prenume">Prenume *</label>
                <input
                  type="text"
                  id="prenume"
                  name="prenume"
                  value={formData.prenume}
                  onChange={handleChange}
                  placeholder="Introduceți prenumele"
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="telefon">Număr de telefon *</label>
              <input
                type="tel"
                id="telefon"
                name="telefon"
                value={formData.telefon}
                onChange={handleChange}
                placeholder="07xxxxxxxx"
                pattern="[0-9]{10}"
                required
              />
            </div>

            <div className="form-group question-group">
              <label className="question-label">
                Sunteți angajat / pensionar de minim 3 luni? *
              </label>
              <div className="radio-group">
                <label className="radio-option">
                  <input
                    type="radio"
                    name="angajat"
                    value="Da"
                    checked={formData.angajat === 'Da'}
                    onChange={handleChange}
                    required
                  />
                  <span className="radio-custom"></span>
                  <span className="radio-text">Da</span>
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="angajat"
                    value="Nu"
                    checked={formData.angajat === 'Nu'}
                    onChange={handleChange}
                    required
                  />
                  <span className="radio-custom"></span>
                  <span className="radio-text">Nu</span>
                </label>
              </div>
            </div>

            <div className="form-group question-group">
              <label className="question-label">
                Aveți datorii neachitate / restanțe la alte bănci? *
              </label>
              <div className="radio-group">
                <label className="radio-option">
                  <input
                    type="radio"
                    name="datorii"
                    value="Da"
                    checked={formData.datorii === 'Da'}
                    onChange={handleChange}
                    required
                  />
                  <span className="radio-custom"></span>
                  <span className="radio-text">Da</span>
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="datorii"
                    value="Nu"
                    checked={formData.datorii === 'Nu'}
                    onChange={handleChange}
                    required
                  />
                  <span className="radio-custom"></span>
                  <span className="radio-text">Nu</span>
                </label>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="alteRate">
                Daca mai aveți alte rate, care este suma lunara pe care o platiți? *
              </label>
              <input
                type="number"
                id="alteRate"
                name="alteRate"
                value={formData.alteRate}
                onChange={handleChange}
                placeholder="Introduceți suma în lei"
                min="0"
                required
              />
              <span style={{display:'flex'}} className="input-hint">Introduceți suma în lei</span>
            </div>

            <div className="form-group">
              <label htmlFor="venitLunar">
                Care este venitul dumneavoastra net (in mana) lunar? *
              </label>
              <input
                type="number"
                id="venitLunar"
                name="venitLunar"
                value={formData.venitLunar}
                onChange={handleChange}
                placeholder="Introduceți venitul în lei"
                min="0"
                required
              />
              <span style={{display:'flex'}} className="input-hint">Introduceți venitul în lei</span>
            </div>

            <button type="submit" className="submit-button">
              <span>Trimite Formular</span>
            </button>
          </form>
          <div className="google-maps">
  <iframe 
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d45576.38315305343!2d25.978729888132087!3d44.44292652510292!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b201a16658d64b%3A0x3663e3d34269a4cc!2sSector%206%2C%20Bucharest!5e0!3m2!1sen!2sro!4v1762884196350!5m2!1sen!2sro" 
    width="600" 
    height="450" 
    style={{ border: 0 }} 
    allowFullScreen="" 
    loading="lazy" 
    referrerPolicy="no-referrer-when-downgrade"
    title="Google Maps - Sector 6, București"
  />
</div>
        </div>
      </main>
    </div>
  );
};

export default ContactPage;